// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__jrSFP","content":"style_content__vpBkF","spinner":"style_spinner__6Tdvw","text":"style_text__P8+zp"};